import React, { useEffect } from 'react';
import ShiftSummaryReportDataTable from './ShiftSummaryReportDataTable';

const ShiftSummaryReportIndex = ({ rrhh }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <ShiftSummaryReportDataTable rrhh={rrhh} />
    </>
  );
};

export default ShiftSummaryReportIndex;
